import apiClient from '@/api/client'

export interface ContactFormRequest {
  name: string
  email: string
  subject: string
  message: string
}

export interface ContactFormResponse {
  message: string
}

export const contactApi = {
  async submit(formData: ContactFormRequest): Promise<ContactFormResponse> {
    const { data } = await apiClient.post<ContactFormResponse>('/api/v1/contact/submit', formData)
    return data
  },
}

